import React from 'react'
import { useState } from 'react'
import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Footer.scss'


const Footer = () => {
  const [formData, setFormData] = useState({name: '', email: '', message: ''});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const {name, email, message} = formData
    
  const handleChangeInput = (e) =>{
    const {name, value} = e.target;

    setFormData({...formData, [name]: value})
  }

  const handleSubmit = () => {
    setLoading(true); 

    const contact = {
      name: name,
      email: email,
      message: message
    }
  }

  return (
    <>
        <h2 className='head-text'>Contact Me</h2>

        <div className='app__footer-cards'>
          <div className='app__footer-card'>
            <img src = {images.email} alt='email'/>
            <a href='mailto:brainbox.sb@gmail.com' className='p-text'>brainbox.sb@gmail.com</a>
          </div>
           <div className='app__footer-card'>
            <img src = {images.mobile} alt='mobile'/>
            <a href='tel:+234(090)66147431' className='p-text'>+234(090)66147431</a>
          </div>
        </div>

      {/* {!isFormSubmitted ? 
        <div className='app__footer-form app__flex'>
          <div className='app__flex'>
            <input className='p-text' type='text' name='name' placeholder='Your Name' value={name} onChange={handleChangeInput} />
          </div>
          <div className='app__flex'>
            <input className='p-text' type='text' name='name' placeholder='Your Email' value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
             className='p-text' 
             placeholder='Your Message' 
             value={message}
             name='message'
             onChange={handleChangeInput}
             />
          </div>
          <button type='button' className='p-text' onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>
        </div>
        : 
        <div>
          <h3 className='head-text'>Thanks for getting in touch</h3>
        </div>
        } */}
    </>
  )
}

export default AppWrap(MotionWrap(Footer, 'app__footer'),
'contact'
)